import { useQuery } from "@tanstack/react-query"
import { CacheKeys } from "../../shared/consts/keys.consts"
import { summaryService } from "./summary.service"


export default function useSummary(){    
    const {isLoading, data: summary, isError} = useQuery({
        queryKey: CacheKeys.summary,
        queryFn: summaryService.get,
    })    

    return { isLoading, summary, isError }
}
